export const getPasswordRequirements = (password: string) => ({
  isPw8Chars: password.length >= 8,
  isPwUpperChar: /[A-Z]/.test(password),
  isPwLowerChar: /[a-z]/.test(password),
  isPwDigit: /[0-9]/.test(password),
});
